module.exports = __webpack_public_path__ + "assets/71f9baeb359af44257926a36e7f6ac8f.jpg";